/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refinetool1Inputs */

const en_refinetool1 = /** @type {(inputs: Refinetool1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refine`)
};

const de_refinetool1 = /** @type {(inputs: Refinetool1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfeinern`)
};

/**
* | output |
* | --- |
* | "Refine" |
*
* @param {Refinetool1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refinetool1 = /** @type {((inputs?: Refinetool1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refinetool1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refinetool1(inputs)
	return de_refinetool1(inputs)
});
export { refinetool1 as "refineTool" }